'use strict';
'use es6';

// These should be removed once we have 100% adoption of UIApplication

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Functions = require('../core/Functions');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _ThrowError = require('../utils/ThrowError');

var _Links = require('../utils/Links');

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _Activeable = require('../decorators/Activeable');

var _Activeable2 = _interopRequireDefault(_Activeable);

var _ShareButton = require('../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _UIClickable = require('./UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _setupStyledComponents.setupStyledComponents)();

var UIButton = _react2.default.createClass({
  displayName: 'UIButton',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    _useNativeButton: _react.PropTypes.bool,
    active: _react.PropTypes.bool,
    autoFocus: _react.PropTypes.bool,
    'aria-pressed': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    buttonRef: _refObject2.default,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    external: _react.PropTypes.bool.isRequired,
    href: _validHref2.default,
    hovered: _react.PropTypes.bool,
    I18n: _react.PropTypes.object,
    iconProps: _react.PropTypes.object.isRequired,
    onClick: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    responsive: _react.PropTypes.bool.isRequired,
    rel: _react.PropTypes.string,
    size: TShirtSize.propTypeForSizes(['xs', 'sm', 'md'], ['default']),
    tabIndex: _react.PropTypes.number,
    target: _react.PropTypes.string,
    truncate: _react.PropTypes.bool.isRequired,
    truncateStringProps: _react.PropTypes.object.isRequired,
    type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _useNativeButton: true,
      disabled: false,
      external: false,
      iconProps: {},
      responsive: true,
      size: 'medium',
      truncate: false,
      truncateStringProps: {},
      type: 'button',
      use: 'secondary'
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        buttonRef = _props.buttonRef,
        href = _props.href;

    if (autoFocus && href) {
      if (buttonRef.current) buttonRef.current.focus();
    }
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;


    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;

    if (this.props.disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  getClassName: function getClassName(_ref, _ref2) {
    var active = _ref.active,
        block = _ref.block,
        className = _ref.className,
        disabled = _ref.disabled,
        hovered = _ref.hovered,
        responsive = _ref.responsive,
        size = _ref.size;
    var computedUse = _ref2.computedUse;

    var unstyled = computedUse === 'unstyled';
    return (0, _reactUtils.classNames)('uiButton', 'private-button', _ButtonConstants.SIZE_CLASSES[size] || _ButtonConstants.SIZE_CLASSES.default, _ButtonConstants.USE_CLASSES[computedUse], className, {
      'private-button--active': active && !unstyled,
      'private-button--block': block && !unstyled,
      'disabled private-button--disabled': disabled && !unstyled,
      'private-button--non-responsive': !responsive,
      'private-button--non-link': _ButtonConstants.LINK_USES.indexOf(computedUse) === -1,
      'private-button--hover': hovered
    });
  },
  getTabIndex: function getTabIndex(_ref3) {
    var disabled = _ref3.disabled,
        tabIndex = _ref3.tabIndex;

    var defaultTabIndex = disabled ? -1 : 0;
    return typeof tabIndex === 'number' ? tabIndex : defaultTabIndex;
  },
  getUse: function getUse(_ref4) {
    var use = _ref4.use;

    return use && _ButtonConstants.USE_CLASSES[use] ? use : 'secondary';
  },
  validateProps: function validateProps() {
    var _props2 = this.props,
        external = _props2.external,
        size = _props2.size,
        target = _props2.target,
        use = _props2.use;

    if (!external && target === '_blank') {
      _devLogger2.default.warn({
        message: 'UIButton: You can use the `external` prop to automatically set ' + 'target="_blank" which adds a trailing external link icon.',
        key: 'UIButton: using target directly'
      });
    }
    if (use === 'form' && size !== 'default') {
      _devLogger2.default.warn({
        message: 'UIButton: size="' + size + '" is not supported with use="form"',
        key: 'UIButton: form size'
      });
    }
  },
  getSecurityTaggedLink: function getSecurityTaggedLink(_ref5, _ref6) {
    var href = _ref5.href;
    var link = _ref6.link;

    if ((0, _UnsafeUrl.isUnsafeUrl)(href)) {
      (0, _ThrowError.throwErrorAsync)(new Error('UIButton: Detected XSS attempt! href="' + href + '"'));
      return _react2.default.createElement(
        _UnsafeUrl.XSSTooltip,
        null,
        link
      );
    }
    return link;
  },
  renderContents: function renderContents(_ref7) {
    var children = _ref7.children;

    var stringBuffer = '';
    var nextChildIndex = 0;
    var childArr = _react.Children.toArray(children);
    return _react.Children.map(children, function (child) {
      nextChildIndex += 1;
      if (child == null) {
        return null;
      }

      // in response to a breaking change in React 0.15
      // (https://facebook.github.io/react/blog/2016/04/07/react-v15.html#no-more-extra-ltspangts)
      // this wraps any bare strings within a <span> to provide a more
      // predictable DOM for applying automatic spacing rules.
      if (typeof child === 'string') {
        stringBuffer += child;
        if (childArr.length < nextChildIndex || typeof childArr[nextChildIndex] !== 'string') {
          var wrappedStringBuffer = _react2.default.createElement(
            'span',
            null,
            stringBuffer
          );
          stringBuffer = '';
          return wrappedStringBuffer;
        } else {
          return null;
        }
      }

      return child;
    });
  },
  renderLink: function renderLink(_ref8, _ref9) {
    var buttonRef = _ref8.buttonRef,
        disabled = _ref8.disabled,
        external = _ref8.external,
        href = _ref8.href,
        rel = _ref8.rel,
        target = _ref8.target,
        truncate = _ref8.truncate,
        rest = _objectWithoutProperties(_ref8, ['buttonRef', 'disabled', 'external', 'href', 'rel', 'target', 'truncate']);

    var computedClassName = _ref9.computedClassName,
        computedTabIndex = _ref9.computedTabIndex,
        wrappedContents = _ref9.wrappedContents,
        renderedExternalButtonIcon = _ref9.renderedExternalButtonIcon;

    var computedTarget = (0, _Links.getTarget)({ external: external, target: target });
    var computedRel = (0, _Links.getRel)({ rel: rel }, { computedTarget: computedTarget });

    var link = _react2.default.createElement(
      'a',
      _extends({}, rest, {
        'aria-disabled': disabled,
        className: computedClassName,
        href: (0, _UnsafeUrl.getSafeUrl)(href),
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        rel: computedRel,
        ref: (0, _Functions.wrapRefObject)(buttonRef),
        tabIndex: computedTabIndex,
        target: computedTarget
      }),
      wrappedContents,
      truncate ? null : renderedExternalButtonIcon
    );
    return this.getSecurityTaggedLink({ href: href }, { link: link });
  },
  renderButton: function renderButton(_ref10, _ref11) {
    var _useNativeButton = _ref10._useNativeButton,
        active = _ref10.active,
        ariaPressed = _ref10.ariaPressed,
        buttonRef = _ref10.buttonRef,
        disabled = _ref10.disabled,
        rest = _objectWithoutProperties(_ref10, ['_useNativeButton', 'active', 'ariaPressed', 'buttonRef', 'disabled']);

    var computedClassName = _ref11.computedClassName,
        computedTabIndex = _ref11.computedTabIndex,
        wrappedContents = _ref11.wrappedContents;

    var ButtonComponent = _useNativeButton ? 'button' : _UIClickable2.default;
    return _react2.default.createElement(
      ButtonComponent,
      _extends({}, rest, {
        'aria-pressed': ariaPressed != null ? ariaPressed : active,
        'aria-disabled': disabled,
        className: computedClassName,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        ref: (0, _Functions.wrapRefObject)(buttonRef),
        tabIndex: computedTabIndex
      }),
      wrappedContents
    );
  },
  renderExternalButtonIcon: function renderExternalButtonIcon(_ref12) {
    var external = _ref12.external,
        I18n = _ref12.I18n,
        iconProps = _ref12.iconProps;

    if (!external) return null;

    // Opening links in a new window is an accessibility anti-pattern.
    // To mitigate this, we add accessible text in the icon to warn that
    // the link will be opened in a new window
    // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

    return _react2.default.createElement(_UIIcon2.default, _extends({}, iconProps, {
      'aria-label': I18n.text('salesUI.UILink.externalTitle'),
      className: iconProps.className || 'private-link--external__icon',
      name: _icons2.default.EXTERNALLINK
    }));
  },
  render: function render() {
    var _props3 = this.props,
        _useNativeButton = _props3._useNativeButton,
        active = _props3.active,
        ariaPressed = _props3['aria-pressed'],
        block = _props3.block,
        buttonRef = _props3.buttonRef,
        children = _props3.children,
        className = _props3.className,
        disabled = _props3.disabled,
        external = _props3.external,
        hovered = _props3.hovered,
        href = _props3.href,
        I18n = _props3.I18n,
        iconProps = _props3.iconProps,
        __onClick = _props3.onClick,
        __onMouseDown = _props3.onMouseDown,
        rel = _props3.rel,
        responsive = _props3.responsive,
        size = _props3.size,
        tabIndex = _props3.tabIndex,
        target = _props3.target,
        truncate = _props3.truncate,
        truncateStringProps = _props3.truncateStringProps,
        use = _props3.use,
        rest = _objectWithoutProperties(_props3, ['_useNativeButton', 'active', 'aria-pressed', 'block', 'buttonRef', 'children', 'className', 'disabled', 'external', 'hovered', 'href', 'I18n', 'iconProps', 'onClick', 'onMouseDown', 'rel', 'responsive', 'size', 'tabIndex', 'target', 'truncate', 'truncateStringProps', 'use']);

    this.validateProps();

    var computedSize = TShirtSize.fromProp(size).long;
    var computedUse = this.getUse({ use: use });
    var computedClassName = this.getClassName({
      active: active,
      block: block,
      className: className,
      disabled: disabled,
      hovered: hovered,
      responsive: responsive,
      size: computedSize
    }, { computedUse: computedUse });
    var computedTabIndex = this.getTabIndex({ disabled: disabled, tabIndex: tabIndex });
    var renderedContents = this.renderContents({
      children: children,
      external: external,
      I18n: I18n,
      iconProps: iconProps
    });
    var renderedExternalButtonIcon = this.renderExternalButtonIcon({
      external: external,
      I18n: I18n,
      iconProps: iconProps
    });
    var wrappedContents = truncate ? _react2.default.createElement(
      _UITruncateString2.default,
      _extends({
        innerClassName: 'private-button__truncate-string',
        useFlex: true,
        fixedChildren: renderedExternalButtonIcon
      }, truncateStringProps),
      _react2.default.createElement(
        'span',
        null,
        renderedContents
      )
    ) : renderedContents;

    return href ? this.renderLink(_extends({
      buttonRef: buttonRef,
      disabled: disabled,
      external: external,
      href: href,
      rel: rel,
      target: target,
      truncate: truncate
    }, rest), {
      computedClassName: computedClassName,
      computedTabIndex: computedTabIndex,
      wrappedContents: wrappedContents,
      renderedExternalButtonIcon: renderedExternalButtonIcon
    }) : this.renderButton(_extends({
      _useNativeButton: _useNativeButton,
      active: active,
      ariaPressed: ariaPressed,
      buttonRef: buttonRef,
      disabled: disabled
    }, rest), { computedClassName: computedClassName, computedTabIndex: computedTabIndex, wrappedContents: wrappedContents });
  }
});

exports.default = (0, _ShareButton2.default)((0, _Activeable2.default)((0, _Hoverable2.default)((0, _Translatable2.default)(UIButton))));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/button/UIButton.js
// module id = 26
// module chunks = 0